import {Component} from '@angular/core';

@Component({
  selector: 'portal-home',
  templateUrl: './home.component.html'
})
export class HomeComponent {

}
